
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certificaciones/offcial-scrum-fundamentals-certification",
      function () {
        return require("private-next-pages/certificaciones/offcial-scrum-fundamentals-certification.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certificaciones/offcial-scrum-fundamentals-certification"])
      });
    }
  